import { combineApiConfigs } from '@wix/premium-fed-sdk/@apis-infra-react';
import { DowngradeQueriesConfig } from '../downgrade-api-client/downgrade.queries'; // TODO: file names ae not consistent
import { UpgradeQueriesConfig } from '../upgrade-api-client/upgrade.config';
export const SwitchQueriesConfig = combineApiConfigs(UpgradeQueriesConfig, DowngradeQueriesConfig);
//# sourceMappingURL=switch.config.js.map